import script from "./ImageAddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageAddBtn.vue?vue&type=script&setup=true&lang=js"

import "./ImageAddBtn.vue?vue&type=style&index=0&id=7d5b34f4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5b34f4"]])

export default __exports__